import React, { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Row, Col, FormGroup, Button, Label } from 'reactstrap';

import Input from '~/components/Input';
import * as ActionsAuth from '~/store/modules/auth/actions';
import history from '~/services/history';
import getValidationErrors from '~/utils/getValidationErrors';

import { Container, Box, Background, Logo, ForgotPassword } from '../styles';

export default function ResetPass() {
	const formRef = useRef(null);
	const dispatch = useDispatch();

	const handleSubmit = useCallback(
		async (elemento) => {
			try {
				const schema = Yup.object().shape({
					email: Yup.string().required('O e-mail é obrigatório'),
				});

				await schema.validate(elemento, {
					abortEarly: false,
				});

				dispatch(ActionsAuth.requestResetPass(elemento));
			} catch (err) {
				if (err instanceof Yup.ValidationError) {
					const errors = getValidationErrors(err);
					formRef.current.setErrors(errors);
				}
			}
		},
		[dispatch]
	);

	function handleVoltar() {
		history.push('login');
	}

	return (
		<Container>
			<Background />
			<Box>
				<Logo />
				<Row className="my-2 " />
				<Form ref={formRef} onSubmit={handleSubmit} className="mt-3">
					<ForgotPassword>Esqueceu sua senha?</ForgotPassword>

					<FormGroup>
						<Label>Digite seu e-mail cadastrado na Lucree</Label>
						<Input
							id="login"
							name="email"
							type="text"
							placeholder="E-mail"
						/>
					</FormGroup>

					<Row className="mt-5">
						<Col>
							<Button
								outline
								color="primary"
								className="buttonComponentOutline"
								onClick={() => handleVoltar()}>
								VOLTAR
							</Button>
						</Col>
						<Col>
							<Button
								type="submit"
								className="buttonComponent"
								color="primary">
								CONFIRMAR
							</Button>
						</Col>
					</Row>
				</Form>
			</Box>
		</Container>
	);
}
